export default __webpack_public_path__ + "static/media/CapaUnsplashImg.a99a8659.png";